
import { handleClaimSite } from "@/futurelayer/connector/util";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({})
export default class TopNavNotificationBarConnectSite extends Vue {
  handleClaimSite() {
    handleClaimSite();
  }
}
